import { RestApiConditionType } from '../Enums/rest-api-condition-type';
import { HttpCodeConditionDatas } from './datas/http-code-condition-datas';
import { LogicalConditionDatas } from './datas/logical-condition-datas';
import { VariableApiConditionDatas } from './datas/variable-api-condition-datas';

export class RestApiCondition {
    public id: number;
    public organizationId: string;
    public viewId: number;
    public restApiConfigurationId: number;
    public name: string;
    public description: string;
    public updateDate: Date;
    public type: RestApiConditionType;
    public isMainCondition: boolean;
    public conditionData: object;

    private _httpCodeConditionDatas: HttpCodeConditionDatas;
    private _logicalConditionDatas: LogicalConditionDatas;
    private _variableApiConditionDatas: VariableApiConditionDatas;

    public get httpCodeConditionDatas() {
        if (this.type != RestApiConditionType.HttpCode) {
            return null;
        }

        if (this.conditionData !== null) {
            this._httpCodeConditionDatas = this.conditionData as HttpCodeConditionDatas;
        } else {
            this._httpCodeConditionDatas = new HttpCodeConditionDatas();
        }

        return this._httpCodeConditionDatas;
    }

    public get logicalConditionDatas() {
        if (this.type != RestApiConditionType.Logical) {
            return null;
        }

        if (this.conditionData !== null) {
            this._logicalConditionDatas = this.conditionData as LogicalConditionDatas;
        } else {
            this._logicalConditionDatas = new LogicalConditionDatas();
        }

        return this._logicalConditionDatas;
    }

    public get variableApiConditionDatas() {
        if (this.type != RestApiConditionType.Variable) {
            return null;
        }

        if (this.conditionData !== null) {
            this._variableApiConditionDatas = this.conditionData as VariableApiConditionDatas;
        } else {
            this._variableApiConditionDatas = new VariableApiConditionDatas();
        }

        return this._variableApiConditionDatas;
    }

    public set httpCodeConditionDatas(value: HttpCodeConditionDatas) {
        this.conditionData = value;
    }

    public set logicalConditionDatas(value: LogicalConditionDatas) {
        this.conditionData = value;
    }

    public set variableApiConditionDatas(value: VariableApiConditionDatas) {
        this.conditionData = value;
    }

    /**
     * Retourne une copie d'une instance de RestApiCondition
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiCondition) {
        if (!!other) {
            const instance = new RestApiCondition();

            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.viewId = other.viewId;
            instance.restApiConfigurationId = other.restApiConfigurationId;
            instance.name = other.name;
            instance.description = other.description;
            instance.updateDate = other.updateDate;
            instance.type = other.type;
            instance.isMainCondition = other.isMainCondition;
            instance.conditionData = other.conditionData;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiCondition
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiCondition[]) {
        if (!!others) {
            let conditions: RestApiCondition[] = [];

            others.forEach((x) => {
                const condition = RestApiCondition.clone(x);
                conditions.push(condition);
            });

            return conditions;
        } else {
            return [];
        }
    }
}
